import { checkBrowser } from '@/plugin/channel/setUserChannel'
import store from '@/store'

let CHANNEL = checkBrowser()

// 内嵌的，判断是webView还是H5的运费时效查询
if (CHANNEL === 'WECHAT' && (navigator.userAgent.includes('miniprogram') || navigator.userAgent.includes('miniProgram'))) {
  CHANNEL = 'WECHAT_MINI_PROGRAM'
}
if (CHANNEL === 'ALIPAY' && (navigator.userAgent.includes('MiniProgram') || navigator.userAgent.includes('miniprogram'))) {
  CHANNEL = 'ALIPAY_MINI_PROGRAM'
}

// const app = otherApp()
// 获取全局状态的函数，当页面调用本文件的时候获取到值
const getState = function () {
  let user = store.state.user
  return {
    ...user
  }
}
//  获取在线客服配置
const visitorInfo = {
  'tenantId': 1000,
  'oldLink': {
    'WECHAT': `http://nmc.ems.com.cn:9096/imcloud/static/unified_page.html`,
    'ALIPAY': 'http://nmc.ems.com.cn:9096/imcloud/static/unified_page.html',
    'APP': `http://nmc.ems.com.cn:9096/imcloud/static/unified_page.html`,
    'WECHAT_MINI_PROGRAM': 'https://nmc.ems.com.cn/imcloud/static/unified_page.html',
    'ALIPAY_MINI_PROGRAM': 'https://nmc.ems.com.cn/imcloud/static/unified_page.html'
  },
  'protocol': {
    'WECHAT': 'http',
    'ALIPAY': 'http',
    'APP': 'http',
    'WECHAT_MINI_PROGRAM': 'https',
    'ALIPAY_MINI_PROGRAM': 'https'
  },
  // 在线客服 渠道参数
  'channel': {
    'WECHAT': 0,
    'ALIPAY': 3,
    'APP': 4,
    'WECHAT_MINI_PROGRAM': 0,
    'ALIPAY_MINI_PROGRAM': 3
  },
  'appId': {
    'WECHAT': process.env.VUE_APP_WX_APPID,
    'ALIPAY': process.env.VUE_APP_ALIPAY_APPID
  },
  'getUrl': function () {
    let state = getState()
    const sacToken = localStorage.getItem('NEW-GENERATION-API-TOKEN') || ''
    return `${this.oldLink[CHANNEL]}` +
      `?protocol=${this.protocol[CHANNEL]}` +
      `&tenantId=${this.tenantId}` +
      `&channel=${this.channel[CHANNEL]}` +
      `&phoneNumber=${state.enCodePhone || ''}` +
      `&openId=${state.openId || ''}` +
      `&userId=${state.userId || ''}` +
      `&appId=${this.appId[CHANNEL] || ''}` +
      `&sacToken=${sacToken}`
  }
}
/**
 * @description: 通过label获取对应的url
 * @param {String} label
 * @return: url
 */
export default function (label) {
  const labelUrl = {
    'onlineServer': visitorInfo.getUrl() // 在线客服
  }
  return labelUrl[label]
}
